<template>
  <div class="home">
    <el-button @click="goToAdmin">后台管理</el-button>
    <el-button @click="goToPortal">门户首页</el-button>
    <el-input placeholder="输入框"></el-input>
    
    <!-- 添加测试接口按钮 -->
    <el-button type="primary" @click="testApi">测试接口</el-button>
    
    <!-- 显示接口返回结果 -->
    <div v-if="apiResult" class="api-result">
      <h3>接口返回结果：</h3>
      <pre>{{ apiResult }}</pre>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import { get, post } from '@/utils/request'
// import { singleAuthorize } from '@/api/index.js'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  },
  data() {
    return {
      apiResult: null
    }
  },
  created() {
    // 在这里可以进行一些初始化操作
    // this.testApi()
    // singleAuthorize({
    //   param1: '',
    //   param2: '',
    //   timestamp: new Date().getTime()
    // }).then(res => {
    //   this.apiResult = res
    //   this.$message({
    //     message: '请求成功',
    //     type:'success'
    //   })
    // })
  },
  methods: {
    //跳转到管理后台
    goToAdmin() {
      this.$router.push({
        path: '/admin/compute/resource'
      })
    },

    //跳转到门户首页
    goToPortal() {
      this.$router.push({
        path: '/portal'
      })
    },
    
    // 测试接口调用方法
    testApi() {
      // 显示加载中
      // this.$message({
      //   message: '接口请求中...',
      //   type: 'info'
      // })
      
      // 调用 GET 请求示例
      // get('/admin-api/system/auth/single-authorize', { 
      //   param1: '',
      //   param2: '',
      //   timestamp: new Date().getTime()
      // })
      //   .then(res => {
      //     this.apiResult = res
      //     this.$message({
      //       message: '请求成功',
      //       type: 'success'
      //     })
      //   })
      //   .catch(err => {
      //     this.apiResult = err.message || '请求失败'
      //     this.$message({
      //       message: '请求失败: ' + (err.message || '未知错误'),
      //       type: 'error'
      //     })
      //   })
      
      // 如果需要测试 POST 请求，可以取消下面的注释
      
      post('/admin-api/system/auth/single-authorize', {
        name: 'test',
        value: 123
      })
        .then(res => {
          this.apiResult = res
          this.$message({
            message: '请求成功',
            type: 'success'
          })
        })
        .catch(err => {
          this.apiResult = err.message || '请求失败'
          this.$message({
            message: '请求失败: ' + (err.message || '未知错误'),
            type: 'error'
          })
        })
      
    }
  }
}
</script>

<style scoped>
.api-result {
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  max-height: 300px;
  overflow: auto;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
